module.exports = __webpack_public_path__ + "static/img/insta-depressed.9b8653a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-simulation/insta-depressed.png
// module id = wsxk
// module chunks = 1